export default "__VITE_ASSET__aZ270zAz__"